import { WKZ } from '@/features/Sparten/shared/types/kfz/types';

export const wkzWithHsnTsn = [
  WKZ.PKW,
  WKZ.KRAFTRAEDER_KRAFTROLLER,
  WKZ.LEICHTKRAFTROLLER_50_125_CCM,
  WKZ.LEICHTKRAFTRAEDER_50_125_CCM,
];
